import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getCars } from "../lib/api";
import { CarCard } from "../components/CarCard";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";

const TYPES = ["All", "Economy", "Sedan", "SUV"];
const PRICES = [
  { label: "Any price", value: "0" },
  { label: "Under $275 / week", value: "275" },
  { label: "Under $330 / week", value: "330" },
  { label: "Under $400 / week", value: "400" },
];

export default function Fleet() {
  const [cars, setCars] = useState([]);
  const [type, setType] = useState("All");
  const [maxPrice, setMaxPrice] = useState("0");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (type !== "All") params.type = type;
    if (maxPrice !== "0") params.max_week = maxPrice;
    getCars(params).then((c) => { setCars(c); setLoading(false); });
  }, [type, maxPrice]);

  return (
    <div data-testid="fleet-page" className="pt-32 pb-24 max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <p className="overline mb-4">The Fleet</p>
        <h1 className="font-serif text-5xl lg:text-6xl tracking-tighter font-light">
          Rideshare-ready cars.
        </h1>
      </motion.div>

      {/* Filters */}
      <div className="flex flex-wrap items-center gap-4 mt-12 mb-10 pb-8 border-b border-white/10">
        <div className="flex flex-wrap gap-2">
          {TYPES.map((t) => (
            <button
              key={t}
              data-testid={`filter-type-${t.toLowerCase()}`}
              onClick={() => setType(t)}
              className={`px-5 py-2 text-sm border transition-colors ${
                type === t ? "bg-white text-black border-white" : "border-white/20 text-white/60 hover:text-white hover:border-white/50"
              }`}
            >
              {t}
            </button>
          ))}
        </div>
        <div className="ml-auto w-full sm:w-56">
          <Select value={maxPrice} onValueChange={setMaxPrice}>
            <SelectTrigger data-testid="filter-price-select" className="rounded-none bg-transparent border-white/20 text-white">
              <SelectValue placeholder="Any price" />
            </SelectTrigger>
            <SelectContent className="bg-[#0F0F0F] border-white/20 text-white rounded-none">
              {PRICES.map((p) => (
                <SelectItem key={p.value} value={p.value} data-testid={`price-option-${p.value}`}>
                  {p.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      {loading ? (
        <p className="text-white/40 py-20 text-center">Loading fleet…</p>
      ) : cars.length === 0 ? (
        <p data-testid="no-cars-message" className="text-white/40 py-20 text-center">
          No vehicles match your filters.
        </p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cars.map((car, i) => (
            <CarCard key={car.slug} car={car} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
